import { render } from "./commonTable.vue?vue&type=template&id=0e820833"
import script from "./commonTable.vue?vue&type=script&lang=js"
export * from "./commonTable.vue?vue&type=script&lang=js"

import "./commonTable.vue?vue&type=style&index=0&id=0e820833&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__